let toastId = 0;

export const TOAST_EVENT_NAME = 'yamatch:toast';

export function showToast({ message, type = 'info', duration = 4000 }) {
  if (!message || typeof window === 'undefined') return;

  toastId += 1;
  window.dispatchEvent(new CustomEvent(TOAST_EVENT_NAME, {
    detail: {
      id: `${Date.now()}-${toastId}`,
      message,
      type,
      duration,
    },
  }));
}
